import { useState, useCallback } from 'react';
import type { UploadResponse, InterviewPlan } from '../api/client';

export type InterviewStep = 'UPLOAD' | 'PREVIEW' | 'INTERVIEW';

export function useInterview() {
  const [step, setStep] = useState<InterviewStep>('UPLOAD');
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [plan, setPlan] = useState<InterviewPlan | null>(null);

  const startPreview = useCallback((data: UploadResponse) => {
    setSessionId(data.session_id);
    setPlan(data.plan_summary);
    setStep('PREVIEW');
  }, []);

  const startInterview = useCallback(() => {
    setStep('INTERVIEW');
  }, []);

  const reset = useCallback(() => {
    setStep('UPLOAD');
    setSessionId(null);
    setPlan(null);
  }, []);

  return {
    step,
    sessionId,
    plan,
    startPreview,
    startInterview,
    reset,
  };
}
